import { JSX } from "react";
import {
  Text,
  View
} from "react-native";
import { useLazyGetShortMonitoringInfoQuery } from "@/_store/monitoringSubscription/monitoring.slice";
import { useGetCurrentUserQuery } from "@/_store/currentUser/currentUser.slice";
import useInnForm from "@/_hooks/useInnForm";
import useErrorHandler from "@/_hooks/Toasters/useHandlerError";
import { isInnValid } from "@/_utils/validation";
import {
  subTitleClass,
  titleClass,
  wrapperLabelBlockClass
} from "@/app/(main)/companyCheck/CompanyCheck";
import {
  labelClass,
  requiredLabelClass,
  textInputClass
} from "@/app/(main)/profile/Feedback";
import ResultSubscriptionCompany from "@/app/(main)/subscriptionCheck/ResultSubscription";
import CustomButton from "@/app/components/CustomButton";
import { IStatItem } from "@/app/components/StatsBlock";
import { usePlatformStyles } from "@/_hooks/usePlatformStyles";
import useFocus from "@/_hooks/useFocus";
import StyledTextInput from "@/app/components/StyledTextInput";

const SubscriptionCheck = (): JSX.Element => {
  const {
    inn,
    handleInnChange,
    hasNoValues,
    setInn
  } = useInnForm();

  const [getShortMonitoringInfo, { data, isFetching }] = useLazyGetShortMonitoringInfoQuery();
  const { data: currentUser } = useGetCurrentUserQuery();
  const { handleError } = useErrorHandler();
  const { webOutlineNone } = usePlatformStyles();
  const innFieldFocus = useFocus();

  const titleCompany: string = data?.name || "";
  const futureInspections: number | undefined = data?.number_of_upcoming;
  const previousInspections: number | undefined = data?.number_of_passed;
  const isButtonDisabled: boolean = isFetching || !isInnValid(inn);

  const handleSubmit = async (): Promise<void> => {
    try {
      if (hasNoValues) return;

      await getShortMonitoringInfo({ inn }).unwrap();
    } catch (err) {
      handleError(err)
    }
  };

  const handleSetMyInn = (): void => {
    if (currentUser?.inn) {
      setInn(currentUser.inn);
    }
  };

  const statsInfoItems: IStatItem[] = [
    { info: "Проверок планируется", value: futureInspections, isFullWidth: true },
    { info: "Проверок пройдено", value: previousInspections, isFullWidth: true},
  ];

  return (
    <>
      <Text className={titleClass}>Выбор компании для отслеживания</Text>
      <Text className={subTitleClass}>
        Добавьте организацию для мониторинга, и мы уведомим вас по электронной почте, если надзорные органы запланируют проверку.
      </Text>
      <View className={wrapperLabelBlockClass}>
        <Text className={requiredLabelClass}>*</Text>
        <Text className={labelClass}>ИНН компании</Text>
      </View>
      <StyledTextInput
        className={textInputClass}
        placeholder="Введите ИНН"
        value={inn}
        style={webOutlineNone}
        onFocus={innFieldFocus.onFocus}
        isFocused={innFieldFocus.isFocused}
        onBlur={innFieldFocus.onBlur}
        maxLength={12}
        onChangeText={handleInnChange}
      />
      <CustomButton
        title="Найти"
        type="primary"
        className="mb-3"
        loading={isFetching}
        onPress={handleSubmit}
        disabled={isButtonDisabled}
      />
      <CustomButton
        title="ИНН моей компании"
        type="default"
        textStyle={{ color: "#101928" }}
        onPress={handleSetMyInn}
        disabled={isFetching}
      />
      {data && !data.subscribed && (
        <ResultSubscriptionCompany
          isLoading={isFetching}
          statsInfo={statsInfoItems}
          title={titleCompany}
          inn={inn}
        />
      )}
    </>
  );
};

export default SubscriptionCheck;
